<template>
    <article class="logos" :class="[getModuleThemeClass(), getModuleModClass()]">
        <h2 v-if="item.Headline" class="logos__headline">{{ item.Headline }}</h2>
        <div v-if="item.RichText" class="rich-text logos__rich-text" v-html="item.RichText"></div>
        <ul v-if="item.Logos.length > 0" class="logos__list">
            <li v-for="(logo, index) in item.Logos" :key="index" class="logos__item">
                <img :src="logo.Image.Path" :alt="logo.Caption" class="logos__image">
            </li>
        </ul>
    </article>
</template>
<script>
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'Logos',
    props: {
        item: {
            type: Object,
            default: null,
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getModuleModClass() {
            return this.item.Logos.length % 4 == 0 ? 'logos--four' : this.item.Logos.length % 3 == 0 ? 'logos--three' : 'logos--two';
        }
    }
};
</script>
